import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import DecorBackground from '@/components/marketing/DecorBackground';

export default function CTASection({
  eyebrow = 'Ready to scale?',
  title = 'Ready to Route Better Traffic to Your Offers?',
  subtitle = 'Submit your advertiser application and let our team review your traffic goals, offer URLs, and launch requirements.',
  primaryLabel = 'Apply as Advertiser',
  primaryTo = '/apply',
  secondaryLabel = 'Contact Team',
  secondaryTo = '/contact',
}) {
  return (
    <section className="relative overflow-hidden bg-[#050B17] text-white isolate" data-testid="final-cta-section">
      <DecorBackground variant="section" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.04] border border-white/10 text-[12px] font-medium text-[#22D3EE] backdrop-blur-md">
            <span className="h-1.5 w-1.5 rounded-full bg-[#22D3EE] pulse-glow" /> {eyebrow}
          </span>
          <h2 className="font-display-tight mt-6 text-[36px] sm:text-[48px] lg:text-[56px] font-bold tracking-[-0.035em] leading-[1.05]">
            {title}
          </h2>
          <p className="mt-5 text-[17px] sm:text-[19px] text-slate-300/90 leading-[1.65]">{subtitle}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button asChild data-testid="cta-primary-button" className="btn-primary-gradient text-white rounded-xl px-7 py-6 text-[15px] font-semibold border-0">
              <Link to={primaryTo} className="inline-flex items-center gap-2">{primaryLabel} <ArrowRight className="h-4 w-4" /></Link>
            </Button>
            <Button asChild variant="outline" data-testid="cta-secondary-button" className="bg-white/[0.04] text-white border-white/15 hover:bg-white/10 hover:text-white rounded-xl px-6 py-6 text-[15px] font-semibold transition-colors backdrop-blur-md">
              <Link to={secondaryTo}>{secondaryLabel}</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
